module.exports = __webpack_public_path__ + "static/media/Eyes_5.52b84dbb.jpg";